import { SiteSpecificData } from '../assets/models/site-specific-data.model';
import { FileHelperService } from '../app/common/services/file-helper.service';

function loadJSON(): SiteSpecificData {
  const fileHelperService = new FileHelperService();
  const jsonString = preProcessSiteSpecificData(fileHelperService.loadTextFileAjaxSync('./assets/site-specific-data.json', 'application/json'));
  return fileHelperService.loadJSON(jsonString) as SiteSpecificData;
}

/**
 * Applies some replacement logic to the siteSpecificData text prior to parsing
 * Hack due to direct data access on the siteSpecificData object not being accessed through a service
 */
function preProcessSiteSpecificData(data: string): string {
  let result = data;
  result = result.replace(new RegExp('{origin}', 'g'), window.location.origin);
  result = result.replace(new RegExp('{protocol}', 'g'), window.location.protocol);
  result = result.replace(new RegExp('{hostname}', 'g'), window.location.hostname);
  return result;
}

export const siteSpecificData: SiteSpecificData = loadJSON();

export enum Feature {
  dynamicCssPoc
}

export function isFeatureOn(feature: Feature) {
  return siteSpecificData && siteSpecificData[Feature[feature]] === true;
}

